<template>
  <section id="about" class="about">
    <h2>About</h2>
    <!-- <img class="selfie" src="/img/self.png" /> -->

    <div class="about__content">
      <div class="about__content__img__wrap">
        <!-- <img class="about__content__img" src="/img/bcard--light.png" /> -->
        &nbsp;
      </div>
      <div class="about__content__txt">
        <p>
          👋 Greetings and salutations!
        </p>
        <p>
          I am a <span class="secondary bold">creative professional</span> with
          years of experience supporting marketing teams with design and code. I
          have worked as a freelancer, joined startup teams, and lead teams
          within corporate environments.
        </p>
        <p>
          Comfortable within <span class="secondary bold">many roles</span>, I
          can switch hats from planning & strategy to creative concepting and
          art direction to production design to front-end develoment and
          optimzation.
        </p>
        <p>
          What keeps me engaged with this field is the merging of
          <span class="secondary bold">art + science</span> in the place where
          design and code meet. Creativity can manifest as artistic expression
          as well as problem solving and process development.
        </p>
        <p>
          I'm a bit of a <span class="secondary bold">tech nerd</span> and enjoy
          not only creating beautiful and functional experiences, but also
          optimizing production processes & systems for maximum efficiency and
          reuse.
        </p>
        <p>
          In my <span class="secondary bold">free time</span> I enjoy traveling,
          learning code frameworks, listening to music, sitting around a firepit
          with a beverage in-hand, and playing with my cats (2 indoor domestic /
          3 outdoor feral).
        </p>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: "About",
  }
</script>

<style lang="scss"></style>
